import React from 'react';
import { useWizardModals } from 'wmic-pe-portals-wizard-components-ui';
import { MODAL_CONSTANTS } from 'wmic-pe-portals-utils-js';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import WMICHOCustomCoverageTermDetailView from '../../WMICHOCustomCoverageTerm/WMICHOCustomCoverageTermDetailView/WMICHOCustomCoverageTermDetailView';
import messages from './WMICHOContentsOffPremisesCovDetailView.messages';
import metadata from './WMICHOContentsOffPremisesCovDetailView.metadata.json5';

function WMICHOContentsOffPremisesCovDetailView(props) {
    const {
        id,
        dwellingVM,
        itemVM,
        onSaveItem,
        onCancelItem,
        onValidate: parentOnValidate,
        showErrors: parentShowErrors,
    } = props;

    const { showError } = useWizardModals();

    const onSaveItemWithValidation = () => {
        const existingItems = dwellingVM?.contentsOffPremisesCovItems?.value;
        const hasMatchingLocation = existingItems?.some(
            item => item?.location?.toLowerCase() === itemVM?.value?.location?.toLowerCase()
        );

        if (hasMatchingLocation) {
            showError({
                status: MODAL_CONSTANTS.STATUS.ERROR,
                icon: MODAL_CONSTANTS.ICON.ERROR,
                title: commonMessages.genericError,
                message: messages.eachLocationRequiresUniqueAddress,
            });
        } else {
            onSaveItem();
        }
    };

    return (
        <WMICHOCustomCoverageTermDetailView
            id={id}
            itemVM={itemVM}
            onSaveItem={onSaveItemWithValidation}
            onCancelItem={onCancelItem}
            onValidate={parentOnValidate}
            showErrors={parentShowErrors}
            content={metadata.componentContent}
        />
    );
}

export default WMICHOContentsOffPremisesCovDetailView;
